<template>
    <div class="md-snapshot-search template2" :style="{ marginBottom }">
        <component
            :is="mdSearchBar"
            :searchBarOnly="true"
            :hideSearch="true"
            ref="search"
            :propsToData="dataToSearchBar"
            @conditionChange="conditionChange"
            v-show="showSearchBar"
        />
        <module-box class="module_box" noPadding noMargin>
            <market-report :title="snapshotMarketTitle" />
        </module-box>
    </div>
</template>

<script>
import MarketReport from './components/market-report/index';
import common from '../index';
import searchBarMixin from '../../md-search-bar-mixin';
export default {
    mixins: [common, searchBarMixin('template1')],
    components: {
        'market-report': MarketReport
    },
    computed: {
        cmpDefaultMoreBtnTitle() {
            return (
                this.defaultMoreBtnTitle ??
                this.$t('md-snapshot-search.requestMoreMarketInsights')
            );
        },
        cmpDefaultListingTitle() {
            return this.$t('md-snapshot-search.recentListings');
        }
    }
};
</script>

<style lang="scss">
@media (max-width: 600px) {
    .md-snapshot-search.template2 .module_box {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        box-sizing: border-box;
        background: #fff;
    }
    .md-snapshot-search.template2 .empty {
        width: 100%;
        height: 20px;
        background: #f7f9fb;
    }
}
</style>
